// extracted by mini-css-extract-plugin
export default {"modal":"Tv","topline":"Uv","img":"Vv","textcontents":"Wv","heading":"Xv","copy":"Yv","link":"Zv","close":"aw","modalinner":"bw","container":"cw"};
    if(module.hot) {
      // 1738836192934
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  